import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router'
import { Observable } from 'rxjs'
import { BpmnModelDto } from '../../../../commons/BpmnModel.dto'
import { ApiService } from '../services/api.service'
import { NavbarService } from '../services/navbar.service'

@Injectable({
  providedIn: 'root',
})
export class BpmnModelResolver implements Resolve<BpmnModelDto> {
  constructor(
    private apiService: ApiService,
    private navbarService: NavbarService,
  ) {}
  public resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<BpmnModelDto> {
    return this.apiService.getBpmnModel(
      route.paramMap.get('orgUuid'),
      route.paramMap.get('modelUuid'),
    )
  }
}
